import React from 'react';
import ContactSection from '../components/sections/ContactSection';

const ContactPage = () => {
  return (
    <div>
      <ContactSection />
    </div>
  );
};

export default ContactPage;
